import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    filterData: undefined
})

const getters = {}

const actions = {
    async get({state, commit}, {page, filterData} = {}) {
        commit('setLoading', true)

        state.filterData = filterData;

        let params = {};
        if (page) {
            if (page.current) params.page = page.current;
            if (page.pageSize) params.page_limit = page.pageSize;
        }
        if (state.filterData) {
            params = {...params, ...state.filterData};
        }

        try {
            const res = await this._vm.axios.get(this._vm.endpoints['ecommerce_payment_method'], {
                params: params
            })

            const {data, meta} = res.data
            commit('updateTableData', data || [])
            commit('updatePagination', normalizePagination(meta))
        } catch (e) {
            commit('updateTableData', [])
        } finally {
            setTimeout(() => {
                commit('setLoading', false)
            }, 250)
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updateTableData(state, data) {
        state.table.data = data
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
